/**
 * 接口基础地址
 * - 开发时建议设为 ''，请求走相对路径 /api/...，由 vue.config.js 代理到后端，避免跨域
 * - 生产环境可设为 ''（与前端同域）或完整接口域名（如 https://xxxx.com）
 */
export const BASE_URL = process.env.VUE_APP_API_BASE_URL || ''

// 简书登录状态（由后端提供的检测接口）
export const CHECK_JIANSHU_LOGIN_URL = '/api/current_user'

export const CHECK_LOGIN_URL = '/api/user/checkLogin'

// 各创作区消耗积分配置（公开可读，供展示）
export const CONFIG_COIN_URL = '/api/config/coin'

// 会员套餐（月度/季度/年度等）
export const MEMBER_MONTHLY_URL = '/api/good/monthly'
// 单独积分购买选项
export const MEMBER_RECHARGE_URL = '/api/good/recharge'
// 会员账户信息（个人中心）
export const MEMBER_ACCOUNT_URL = '/api/member/account'
// 账户注销（URL 待定，按后端实际修改）
export const CANCEL_ACCOUNT_URL = '/api/member/account/cancel'
// 我的小说列表
export const MEMBER_NOVELS_URL = '/api/member/work'
// 签约合同
export const CONTRACT_VIEW_URL = '/api/esign/create'
// 查看/下载合同（返回 path 为文件下载地址）
export const CONTRACT_DOWNLOAD_URL = '/api/esign/download'
// 消费记录
export const CONSUME_HISTORY_URL = '/api/member/consume/history'
// 开具发票：可开票列表（分页）、提交开票
export const INVOICE_LIST_URL = '/api/invoice/orderList'
export const INVOICE_SUBMIT_URL = '/api/invoice/submit'
// 支付
export const PAY_GO_URL = '/api/pay/go'
// 支付宝支付结果查询
export const PAY_QUERY_URL = '/api/pay/query'

// 我的资产 - 查看全部列表
export const MEMBER_WORK_LIST_URL = '/api/member/create'

// 问题反馈
export const FEEDBACK_SUBMIT_URL = '/api/feedback/submit'

// 封面生成
export const COVER_WRITE_URL = '/api/cover/write'

// 短篇小说创作
export const WORK_URL = '/api/shortNovel/work/write'
export const WORK_UPLOAD_URL = '/api/shortNovel/work/writeUpload'

// 核心梗提取
export const CORE_IDEA_WORK_URL = '/api/coreIdea/work/write'
export const CORE_IDEA_WORK_UPLOAD_URL = '/api/coreIdea/work/writeUpload'

// 大纲提取
export const OUTLINE_WORK_URL = '/api/outline/work/write'
export const OUTLINE_WORK_UPLOAD_URL = '/api/outline/work/writeUpload'

// 任务查询
export const WORK_TASK_QUERY_URL = '/api/work/task/query'
// 任务更新（修改作品名称/内容）
export const WORK_TASK_UPDATE_URL = '/api/work/task/update'

// 小说一键签约
export const WORK_SIGN_URL = '/api/work/task/sign'
// 小说发布到简书
export const WORK_PUSH_URL = '/api/work/task/push'

// 长篇小说创作
export const LONG_WORK_URL = '/api/longNovel/work/write'
export const LONG_WORK_UPLOAD_URL = '/api/longNovel/work/writeUpload'
// 长篇小说一键签约
export const LONG_WORK_SIGN_URL = '/api/longNovel/work/sign'
// 长篇小说发布到简书
export const LONG_WORK_PUSH_URL = '/api/longNovel/work/push'

